import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { SectionWrapper } from './ui';
export const PainPoints = () => {
  const pains = ['Escribís los mismos mails difíciles una y otra vez sin saber cómo arrancarlos', 'Tus propuestas tardan horas y aun así no cierran como querés', 'Abrís ChatGPT, la pantalla está en blanco y no sabés qué escribirle', 'Generás contenido para redes de forma irregular porque no tenés sistema', 'Tomás decisiones importantes sin tener los datos analizados correctamente', 'Tu negocio depende de que estés vos presente en cada paso de la operación', 'Cobrás menos de lo que valés porque no podés justificar un precio más alto', 'Cada semana arranca igual: caos, urgencias y sensación de no avanzar'];
  return <SectionWrapper className="bg-dark-bg" data-id="element-112">
      <div className="max-w-4xl mx-auto" data-id="element-113">
        <div className="text-center mb-12" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-115">
            ¿Cuántas horas más vas a perder haciendo a mano lo que la IA puede{' '}
            <span className="text-accent border-b-4 border-accent" data-id="element-116">
              hacer en minutos?
            </span>
          </h2>
          <p className="text-xl text-cyan-50/90 mb-4" data-id="element-117">
            Sos profesional. Emprendedor. Dueño de negocio. Freelancer. Trabajás
            mucho. Pero nadie te dijo que ibas a trabajar 11 horas por día
            haciendo cosas repetitivas que una IA puede resolver en segundos.
          </p>
          <p className="text-2xl font-bold text-primary" data-id="element-118">
            No es falta de capacidad. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-dark-card border border-red-500/20 rounded-2xl p-6 md:p-10 shadow-2xl" data-id="element-119">
          <p className="text-sm uppercase tracking-widest text-red-400 font-bold mb-6" data-id="element-120">
            ❌ Esto te pasa hoy y te está costando tiempo y dinero:
          </p>
          <ul className="space-y-5" data-id="element-121">
            {pains.map((pain, index) => <li key={index} className="flex items-start gap-4" data-id="element-122">
                <XCircleIcon className="text-red-400 shrink-0 mt-1" size={24} data-id="element-123" />
                <span className="text-lg text-cyan-50/90" data-id="element-124">{pain}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-125">
          <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-126">
            🔥 ¿Y si este fuera el{' '}
            <span className="text-primary" data-id="element-127">último mes</span> que trabajás sin un
            sistema de IA?
          </h3>
        </div>
      </div>
    </SectionWrapper>;
};
export const CostTable = () => {
  const costs = [{
    sin: 'Sin sistema de prompts',
    costo: 'Entre 2 y 4 horas perdidas por día en tareas que la IA resuelve en minutos'
  }, {
    sin: 'Sin sistema de comunicación',
    costo: 'Propuestas que no cierran, mensajes que no generan respuesta, relaciones que se desgastan'
  }, {
    sin: 'Sin sistema de contenido',
    costo: 'Presencia digital inconsistente, audiencia que no crece, clientes potenciales que no llegan'
  }, {
    sin: 'Sin análisis de datos',
    costo: 'Decisiones basadas en intuición en un mercado que no perdona los errores'
  }, {
    sin: 'Sin sistema de ventas',
    costo: 'Dejás dinero sobre la mesa en cada propuesta y cada conversación comercial'
  }, {
    sin: 'Sin sistema de gestión',
    costo: 'Tu negocio depende de que estés vos presente. No podés crecer. No podés delegar. No podés descansar.'
  }];
  return <SectionWrapper className="bg-dark-card/30 border-t border-dark-border" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <div className="text-center mb-12" data-id="element-130">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-131">
            ⚖️ ¿CUÁNTO CUESTA <span className="text-red-400" data-id="element-132">NO TENERLO?</span>
          </h2>
        </div>

        <div className="overflow-x-auto rounded-xl border border-dark-border shadow-xl" data-id="element-133">
          <table className="w-full text-left border-collapse" data-id="element-134">
            <thead data-id="element-135">
              <tr className="bg-dark-card border-b border-dark-border" data-id="element-136">
                <th className="p-4 md:p-6 text-lg font-bold text-red-400 w-1/2" data-id="element-137">
                  Sin SUPERKIT IA
                </th>
                <th className="p-4 md:p-6 text-lg font-bold text-white w-1/2 border-l border-dark-border" data-id="element-138">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-139">
              {costs.map((item, i) => <tr key={i} className="border-b border-dark-border/50 hover:bg-dark-card/50 transition-colors" data-id="element-140">
                  <td className="p-4 md:p-6 text-cyan-50 font-medium" data-id="element-141">
                    {item.sin}
                  </td>
                  <td className="p-4 md:p-6 text-cyan-100/70 border-l border-dark-border/50" data-id="element-142">
                    {item.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-12" data-id="element-143">
          <p className="text-white text-xl mb-2 font-medium" data-id="element-144">
            La próxima semana puede ser diferente.
          </p>
          <p className="text-2xl text-primary font-bold italic" data-id="element-145">
            "La próxima semana puede ser la primera con un sistema de IA que
            trabaja por vos." 🤖
          </p>
        </div>
      </div>
    </SectionWrapper>;
};